export default {
  data: function data() {
    return {};
  },
  watch: {
    model: {
      handler: function handler(val) {
        this.$emit('input', val);
      },
      deep: true
    },
    value: {
      handler: function handler(val) {
        if (val != null && val['id'] != null) {
          this.$set(this, 'model', val);
        }
      },
      immediate: true
    }
  }
};